export const timeoutDuration = 30000

export enum Status {
  ARMED_PERIMETER = 'perimeter',
  ARMED_AREA_1 = 'area_one',
  ARMED_AREA_2 = 'area_two',
  SIMPLE_ARMED = 'armed',
  SIMPLE_DISARMED = 'disarmed',
}
